var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"knowledge-base-shell",class:{ embedded: _vm.embedded }},[_c('KnowledgeWorkspace',{attrs:{"ck":_vm.ck,"creation-preset":_vm.creationPreset,"creation-preset-key":_vm.creationPresetKey},on:{"close":function($event){return _vm.$emit('close')},"notify":_vm.notify}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }